module.exports = __webpack_public_path__ + "static/media/logo.ceec69e8.svg";